import { createFileRoute } from "@tanstack/react-router";
import { ProductAnalyticsErrorsListPage } from "../../../../components/system/ProductAnalyticsErrorsListPage";
import { requireSuperAdmin } from "../../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/product-analytics/errors/")({
  beforeLoad: requireSuperAdmin(),
  component: ProductAnalyticsErrorsListPage,
});
